module.exports = __webpack_public_path__ + "static/media/JL.caab213f.png";